/* Canvas Classics — 2026 Redesign · Theme JS */
(function() {
  'use strict';

  // ===========================================================
  // PDP — Frame configurator + Size selector + Sticky ATC
  // ===========================================================
  const buybox = document.querySelector('[data-buybox]');
  if (buybox) initBuybox(buybox);

  function initBuybox(box) {
    const product = JSON.parse(box.dataset.product || '{}');
    if (!product.variants) return;

    const state = {
      size: box.dataset.defaultSize || 'Medium',
      sizeKey: (box.dataset.defaultSizeKey || 'medium').toLowerCase(),
      frame: box.dataset.defaultFrame || 'Gold',
      frameKey: (box.dataset.defaultFrameKey || 'gold').toLowerCase().replace(/\s+/g, '_'),
      variant: null,
      // 'framed' = showing the finish-aware mockup; 'supplemental' = showing a rail/strip image.
      mode: 'framed'
    };

    const els = {
      sizeCards: box.querySelectorAll('[data-size-card]'),
      frameCards: box.querySelectorAll('[data-frame-card]'),
      galleryMain: document.querySelector('[data-gallery-main-img]'),
      thumbs: document.querySelectorAll('[data-gallery-thumb]'),
      suppThumbs: document.querySelectorAll('[data-supp-thumb]'),
      caption: document.querySelector('[data-gallery-caption]'),
      captionText: document.querySelector('[data-gallery-caption-text]'),
      priceDisplays: document.querySelectorAll('[data-price-display]'),
      atcButton: box.querySelector('[data-atc]'),
      sizeValue: box.querySelector('[data-size-value]'),
      frameValue: document.querySelector('[data-frame-value]'),
      stickyImg: document.querySelector('[data-sticky-atc-img]'),
      stickyVariant: document.querySelector('[data-sticky-atc-variant]'),
      stickyPrice: document.querySelector('[data-sticky-atc-price]'),
      variantInput: box.querySelector('[name="id"]')
    };

    els.priceDisplays.forEach(el => {
      if (!el.hasAttribute('aria-live')) {
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'true');
      }
    });

    function findVariant() {
      return product.variants.find(v => {
        // Normalize underscores to spaces so "dark_bronze" in the variant title matches the
        // "Dark Bronze" frame name (without this, dark bronze never resolves a variant).
        const opts = (v.title || '').toLowerCase().replace(/_/g, ' ');
        return opts.includes(state.size.toLowerCase()) && opts.includes(state.frame.toLowerCase());
      });
    }

    function formatMoney(cents) {
      const amount = cents / 100;
      const formatted = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
      return '$' + formatted;
    }

    function getAtcLabelNode(button) {
      if (!button) return null;
      let label = button.querySelector('[data-atc-label]');
      if (label) return label;
      label = document.createElement('span');
      label.setAttribute('data-atc-label', '');
      const text = button.firstChild && button.firstChild.nodeType === Node.TEXT_NODE ? button.firstChild : null;
      if (text) {
        label.textContent = text.textContent.trim();
        button.replaceChild(label, text);
      } else {
        label.textContent = 'Add to Cart';
        button.insertBefore(label, button.firstChild);
      }
      return label;
    }

    function resolveVariantImage(variant) {
      if (variant && variant.featured_image && variant.featured_image.src) {
        return variant.featured_image.src;
      }
      const galleryPattern = box.dataset.galleryPattern;
      if (galleryPattern && galleryPattern.indexOf('__SIZE__SLOT__FRAME__') !== -1) {
        return galleryPattern.replace('__SIZE__SLOT__FRAME__', state.sizeKey + '__' + state.frameKey);
      }
      return null;
    }

    function refresh() {
      state.variant = findVariant();
      if (!state.variant) return;

      const price = formatMoney(state.variant.price);
      els.priceDisplays.forEach(el => { el.innerHTML = price + ' <small>USD</small>'; });
      if (els.atcButton) {
        const label = getAtcLabelNode(els.atcButton);
        if (label) label.textContent = 'Add to Cart — ' + price + ' ';
      }
      if (els.variantInput) els.variantInput.value = state.variant.id;

      if (els.sizeValue) {
        const match = state.variant.option1 ? (state.variant.option1.match(/\(([^)]+)\)/) || [null, state.variant.option1.replace(/^[^(]+/, '').trim()]) : null;
        const dimText = match ? ' (' + match[1] + ')' : '';
        els.sizeValue.textContent = state.size + dimText + ' — ' + price;
      }
      if (els.frameValue) els.frameValue.textContent = state.frame;

      const imgUrl = resolveVariantImage(state.variant);
      if (imgUrl) {
        // While a supplemental image is showing, don't clobber the main preview — but keep
        // the sticky-ATC thumbnail tied to the actual variant going into the cart.
        if (els.galleryMain && state.mode !== 'supplemental') {
          els.galleryMain.removeAttribute('srcset');
          els.galleryMain.src = imgUrl;
        }
        if (els.stickyImg) els.stickyImg.src = imgUrl;
      }

      if (els.stickyVariant) els.stickyVariant.textContent = state.size + ' · ' + state.frame;
      if (els.stickyPrice) els.stickyPrice.textContent = price;
    }

    // Shows the "Representative" caption only for the shared/generic shots, so they read as
    // representative of our craft rather than a photo of this specific artwork.
    function updateCaption(thumb) {
      if (!els.caption) return;
      if (thumb && thumb.hasAttribute('data-representative')) {
        if (els.captionText) els.captionText.textContent = thumb.getAttribute('aria-label') || '';
        els.caption.hidden = false;
      } else {
        els.caption.hidden = true;
      }
    }

    // Any size/frame change returns to the framed mockup and re-activates its rail thumb,
    // so the finish×size selector is never left stranded on a supplemental image.
    function returnToFramed() {
      state.mode = 'framed';
      els.suppThumbs.forEach(t => t.classList.toggle('is-active', t.hasAttribute('data-framed')));
      updateCaption(null);
    }

    els.sizeCards.forEach(card => {
      card.addEventListener('click', e => {
        e.preventDefault();
        els.sizeCards.forEach(c => {
          c.classList.remove('selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('selected');
        card.setAttribute('aria-checked', 'true');
        state.size = card.dataset.sizeName;
        state.sizeKey = card.dataset.sizeKey.toLowerCase();
        returnToFramed();
        refresh();
      });
    });

    // Frame is selected directly from the framed-image thumbs under the mockup.
    els.thumbs.forEach(thumb => {
      thumb.addEventListener('click', e => {
        e.preventDefault();
        state.frame = thumb.dataset.frameName;
        state.frameKey = (thumb.dataset.frameKey || '').toLowerCase().replace(/\s+/g, '_');
        els.thumbs.forEach(t => {
          t.classList.toggle('active', t === thumb);
          t.setAttribute('aria-checked', t === thumb ? 'true' : 'false');
        });
        returnToFramed();
        refresh();
      });
    });

    // Supplemental thumbnails (rail on desktop, scroll strip on mobile): swap the single
    // main preview. The framed thumb returns to the finish-aware mockup; the others show a
    // product-specific or shared quality image without touching the frame selector.
    els.suppThumbs.forEach(thumb => {
      thumb.addEventListener('click', e => {
        e.preventDefault();
        els.suppThumbs.forEach(t => t.classList.toggle('is-active', t === thumb));
        if (thumb.hasAttribute('data-framed')) {
          state.mode = 'framed';
          const imgUrl = resolveVariantImage(state.variant);
          if (imgUrl && els.galleryMain) {
            els.galleryMain.removeAttribute('srcset');
            els.galleryMain.src = imgUrl;
          }
        } else if (els.galleryMain && thumb.dataset.full) {
          state.mode = 'supplemental';
          els.galleryMain.removeAttribute('srcset');
          els.galleryMain.src = thumb.dataset.full;
        }
        updateCaption(thumb);
      });
    });

    refresh();
  }

  // ===========================================================
  // Gallery lightbox — click the main preview to view it full-screen.
  // Shows whatever image is currently in the preview (framed mockup or
  // supplemental shot). Click anywhere, the × button, or Esc closes.
  // ===========================================================
  const zoomImg = document.querySelector('[data-gallery-main-img]');
  if (zoomImg) {
    const lightbox = document.createElement('div');
    lightbox.className = 'gallery-lightbox';
    lightbox.innerHTML = '<button type="button" class="gallery-lightbox-close" aria-label="Close full-screen view">&times;</button><img alt="">';
    document.body.appendChild(lightbox);
    const lightboxImg = lightbox.querySelector('img');
    const closeLightbox = () => {
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
    };
    zoomImg.addEventListener('click', () => {
      lightboxImg.src = zoomImg.src;
      lightboxImg.alt = zoomImg.alt;
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    lightbox.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
    });
  }

  // ===========================================================
  // Sticky ATC — visible whenever the form's real ATC button is off-screen
  // (bottom-docked on mobile, top bar on desktop), so a CTA is always in
  // reach while configuring. Falls back to the old past-the-buybox scroll
  // check where IntersectionObserver is unavailable.
  // ===========================================================
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const buyboxSection = document.querySelector('[data-buybox-section]');
  const formAtc = document.querySelector('[data-atc]');
  if (stickyAtc && formAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
    }).observe(formAtc);
  } else if (stickyAtc && buyboxSection) {
    window.addEventListener('scroll', () => {
      const buyboxBottom = buyboxSection.offsetTop + buyboxSection.offsetHeight - 200;
      stickyAtc.classList.toggle('visible', window.scrollY > buyboxBottom);
    }, { passive: true });
  }

  // ===========================================================
  // Collection filter form — submit on any input change.
  // ===========================================================
  document.querySelectorAll('[data-collection-filters-form]').forEach(form => {
    let priceDebounce;

    function submitFilters() {
      const data = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of data.entries()) {
        if (v !== '' && v != null) params.append(k, v);
      }
      params.delete('page');
      const base = form.getAttribute('action') || window.location.pathname;
      const qs = params.toString();
      window.location.href = qs ? base + '?' + qs : base;
    }

    form.addEventListener('change', e => {
      const t = e.target;
      if (!t) return;
      if (t.matches('[data-filter-input]') || t.matches('[data-sort-select]')) {
        if (t.type === 'number') return;
        submitFilters();
      }
    });

    form.addEventListener('input', e => {
      const t = e.target;
      if (t && t.type === 'number' && t.matches('[data-filter-input]')) {
        clearTimeout(priceDebounce);
        priceDebounce = setTimeout(submitFilters, 700);
      }
    });

    const sortSelect = document.querySelector('[data-sort-select][form="' + form.id + '"]');
    if (sortSelect && !form.contains(sortSelect)) {
      sortSelect.addEventListener('change', submitFilters);
    }
  });

  // ===========================================================
  // Mobile filter drawer — open/close the filter rail on small screens.
  // ===========================================================
  const filtersAside = document.querySelector('[data-collection-filters]');
  const filtersTrigger = document.querySelector('[data-filters-trigger]');
  const filtersClose = document.querySelector('[data-filters-close]');
  const filtersBackdrop = document.querySelector('[data-filters-backdrop]');
  if (filtersAside && filtersTrigger) {
    const openFilters = () => {
      filtersAside.classList.add('is-open');
      if (filtersBackdrop) filtersBackdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    };
    const closeFilters = () => {
      filtersAside.classList.remove('is-open');
      if (filtersBackdrop) filtersBackdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    };
    filtersTrigger.addEventListener('click', openFilters);
    if (filtersClose) filtersClose.addEventListener('click', closeFilters);
    if (filtersBackdrop) filtersBackdrop.addEventListener('click', closeFilters);
  }

  // ===========================================================
  // Mobile NAV drawer — hamburger menu (small screens).
  //
  // The CSS is keyed off body.drawer-is-open (NOT body.drawer-open or a class
  // on the drawer element). Specifically:
  //   body.drawer-is-open .drawer        → transform: translate(0), visibility: visible
  //   body.drawer-is-open .drawer-backdrop → opacity: 1, visibility: visible
  //   body.drawer-is-open .hamburger-bars → animates into X
  //   body.drawer-is-open                 → overflow: hidden (lock scroll)
  // ===========================================================
  const navDrawer = document.querySelector('[data-drawer]');
  const navDrawerBackdrop = document.querySelector('[data-drawer-backdrop]');

  function openNavDrawer() {
    document.body.classList.add('drawer-is-open');
    if (navDrawer) navDrawer.setAttribute('aria-hidden', 'false');
    if (navDrawerBackdrop) navDrawerBackdrop.setAttribute('aria-hidden', 'false');
    const trigger = document.querySelector('[data-drawer-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeNavDrawer() {
    document.body.classList.remove('drawer-is-open');
    if (navDrawer) navDrawer.setAttribute('aria-hidden', 'true');
    if (navDrawerBackdrop) navDrawerBackdrop.setAttribute('aria-hidden', 'true');
    const trigger = document.querySelector('[data-drawer-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function(e) {
    const openTrigger = e.target.closest('[data-drawer-open]');
    const closeTrigger = e.target.closest('[data-drawer-close]');
    const softClose = e.target.closest('[data-drawer-close-soft]');
    const accordionToggle = e.target.closest('[data-drawer-toggle]');

    if (openTrigger) {
      e.preventDefault();
      openNavDrawer();
      return;
    }
    if (closeTrigger) {
      e.preventDefault();
      closeNavDrawer();
      return;
    }
    if (accordionToggle) {
      e.preventDefault();
      const item = accordionToggle.closest('[data-drawer-item]');
      if (item) {
        const wasExpanded = accordionToggle.getAttribute('aria-expanded') === 'true';
        item.parentElement.querySelectorAll('[data-drawer-item].is-open').forEach(sib => {
          if (sib !== item) {
            sib.classList.remove('is-open');
            const btn = sib.querySelector('[data-drawer-toggle]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('is-open', !wasExpanded);
        accordionToggle.setAttribute('aria-expanded', wasExpanded ? 'false' : 'true');
      }
      return;
    }
    if (softClose) {
      closeNavDrawer();
    }
  });

  if (navDrawerBackdrop) {
    navDrawerBackdrop.addEventListener('click', closeNavDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.body.classList.contains('drawer-is-open')) {
      closeNavDrawer();
    }
  });

  // ===========================================================
  // Cart drawer + cart page — open/close, qty, remove, AJAX update.
  // ===========================================================
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartBackdrop = document.querySelector('[data-cart-backdrop]');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
    }
    if (cartBackdrop) {
      cartBackdrop.classList.add('is-visible');
      cartBackdrop.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('cart-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
    if (cartBackdrop) {
      cartBackdrop.classList.remove('is-visible');
      cartBackdrop.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('cart-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    const openTrigger = e.target.closest('[data-cart-open]');
    const closeTrigger = e.target.closest('[data-cart-close]');
    const softClose = e.target.closest('[data-cart-close-soft]');
    if (openTrigger) {
      e.preventDefault();
      openCart();
    } else if (closeTrigger) {
      e.preventDefault();
      closeCart();
    } else if (softClose) {
      closeCart();
    }
  });
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
      closeCart();
    }
  });

  const isCartPage = /^\/cart(\/?|\?.*)?$/.test(location.pathname + location.search);

  async function refreshCartCount() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        if (cart.item_count > 0) {
          el.textContent = cart.item_count;
          el.style.display = '';
        } else {
          el.textContent = '0';
          el.style.display = 'none';
        }
      });
    } catch (e) { /* ignore */ }
  }

  async function refreshCartDrawer() {
    try {
      const resp = await fetch('/?sections=cart-drawer');
      if (!resp.ok) return;
      const json = await resp.json();
      const html = json['cart-drawer'];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('[data-cart-drawer]');
      const oldDrawer = document.querySelector('[data-cart-drawer]');
      if (newDrawer && oldDrawer) {
        const wasOpen = oldDrawer.classList.contains('is-open');
        oldDrawer.innerHTML = newDrawer.innerHTML;
        if (wasOpen) oldDrawer.classList.add('is-open');
      }
    } catch (e) { /* ignore */ }
  }

  async function updateCartItem(key, quantity) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!r.ok) throw new Error('Cart update failed');
      if (isCartPage) {
        location.reload();
        return;
      }
      await refreshCartDrawer();
      await refreshCartCount();
    } catch (err) {
      console.error('Cart update error:', err);
    }
  }

  // Swap a line item to a different variant (e.g. a different size or frame)
  // without making the shopper delete and re-find the product. The Cart AJAX
  // API can't mutate a line's variant in place, so add the new variant first
  // (safe), then zero out the old line.
  async function changeCartVariant(item, newId) {
    const oldKey = item.dataset.key;
    const qtyInput = item.querySelector('[data-qty-input]');
    const qty = Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10) || 1);
    try {
      const addResp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: newId, quantity: qty })
      });
      if (!addResp.ok) throw new Error('Add failed');
      const changeResp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: oldKey, quantity: 0 })
      });
      if (!changeResp.ok) throw new Error('Remove failed');
      if (isCartPage) { location.reload(); return; }
      await refreshCartDrawer();
      await refreshCartCount();
    } catch (err) {
      console.error('Variant change error:', err);
      location.reload();
    }
  }

  document.addEventListener('change', function(e) {
    const sel = e.target.closest('[data-variant-size],[data-variant-frame]');
    if (!sel) return;
    const item = sel.closest('[data-cart-item]');
    if (!item) return;
    const sizeSel = item.querySelector('[data-variant-size]');
    const frameSel = item.querySelector('[data-variant-frame]');
    const mapEl = item.querySelector('[data-variant-map]');
    if (!sizeSel || !frameSel || !mapEl) return;
    let variants;
    try { variants = JSON.parse(mapEl.textContent); } catch (_) { return; }
    const currentId = parseInt(item.dataset.variantId, 10);
    const match = variants.find(v => v.o1 === sizeSel.value && v.o2 === frameSel.value);
    if (!match || !match.available) {
      // Combo doesn't exist / is sold out — snap the selects back.
      const cur = variants.find(v => v.id === currentId);
      if (cur) { sizeSel.value = cur.o1; frameSel.value = cur.o2; }
      return;
    }
    if (match.id === currentId) return;
    sizeSel.disabled = true;
    frameSel.disabled = true;
    changeCartVariant(item, match.id);
  });

  document.addEventListener('click', function(e) {
    const decreaseBtn = e.target.closest('[data-qty-decrease]');
    const increaseBtn = e.target.closest('[data-qty-increase]');
    const removeBtn = e.target.closest('[data-cart-remove]');

    if (decreaseBtn) {
      e.preventDefault();
      const item = decreaseBtn.closest('[data-cart-item]');
      if (!item) return;
      const input = item.querySelector('[data-qty-input]');
      const current = parseInt(input ? input.value : '1', 10) || 1;
      const next = Math.max(0, current - 1);
      if (input) input.value = next;
      updateCartItem(item.dataset.key, next);
    } else if (increaseBtn) {
      e.preventDefault();
      const item = increaseBtn.closest('[data-cart-item]');
      if (!item) return;
      const input = item.querySelector('[data-qty-input]');
      const current = parseInt(input ? input.value : '0', 10) || 0;
      const next = current + 1;
      if (input) input.value = next;
      updateCartItem(item.dataset.key, next);
    } else if (removeBtn) {
      e.preventDefault();
      const item = removeBtn.closest('[data-cart-item]');
      if (!item) return;
      updateCartItem(item.dataset.key, 0);
    }
  });

  let qtyTypeDebounce;
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-qty-input]')) {
      const item = e.target.closest('[data-cart-item]');
      if (!item) return;
      const v = Math.max(0, parseInt(e.target.value || '0', 10) || 0);
      e.target.value = v;
      clearTimeout(qtyTypeDebounce);
      qtyTypeDebounce = setTimeout(() => updateCartItem(item.dataset.key, v), 200);
    }
  });

  // ===========================================================
  // Newsletter — submit to Klaviyo via klaviyo.js if loaded.
  // ===========================================================
  document.querySelectorAll('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', function (e) {
      const emailInput = form.querySelector('input[name="email"]');
      const email = emailInput && emailInput.value && emailInput.value.trim();
      if (!email) return;

      if (typeof window._learnq !== 'undefined' || typeof window.klaviyo !== 'undefined') {
        e.preventDefault();
        try {
          var _learnq = window._learnq = window._learnq || [];
          _learnq.push(['identify', { '$email': email, '$source': form.dataset.source || 'newsletter' }]);
          _learnq.push(['track', 'Subscribed to Newsletter', {
            source: form.dataset.source || 'newsletter',
            list_id: form.dataset.klaviyoListId || null
          }]);
        } catch (err) { /* swallow */ }
        const labelEl = form.querySelector('.btn-label');
        const loadingEl = form.querySelector('.btn-loading');
        if (labelEl) labelEl.textContent = 'Subscribed ✓';
        if (loadingEl) loadingEl.style.display = 'none';
        const btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        if (emailInput) emailInput.disabled = true;
        form.classList.add('newsletter-success');
      }
    });
  });

  // ===========================================================
  // Predictive search overlay — the header search icon opens an
  // overlay with live product suggestions (/search/suggest.json)
  // plus the suggested-search chips. Keyed off body.search-is-open
  // (mirrors the nav/cart drawer pattern). Progressive enhancement:
  // the form still submits to /search and the chips are real links.
  // ===========================================================
  const psOverlay = document.querySelector('[data-search-overlay]');
  if (psOverlay) {
    const psBackdrop = document.querySelector('[data-search-backdrop]');
    const psInput = psOverlay.querySelector('[data-search-input]');
    const psResults = psOverlay.querySelector('[data-search-results]');
    let psLastTrigger = null;
    let psDebounce;
    let psReqId = 0;

    function openSearch(trigger) {
      psLastTrigger = trigger || document.querySelector('[data-search-open]');
      document.body.classList.add('search-is-open');
      psOverlay.setAttribute('aria-hidden', 'false');
      if (psBackdrop) psBackdrop.setAttribute('aria-hidden', 'false');
      if (psLastTrigger) psLastTrigger.setAttribute('aria-expanded', 'true');
      setTimeout(function() { if (psInput) psInput.focus(); }, 60);
    }

    function closeSearch() {
      document.body.classList.remove('search-is-open');
      psOverlay.setAttribute('aria-hidden', 'true');
      if (psBackdrop) psBackdrop.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('[data-search-open]').forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
      if (psLastTrigger && typeof psLastTrigger.focus === 'function') psLastTrigger.focus();
    }

    document.addEventListener('click', function(e) {
      const openTrigger = e.target.closest('[data-search-open]');
      const closeTrigger = e.target.closest('[data-search-close]');
      if (openTrigger) {
        e.preventDefault();
        openSearch(openTrigger);
      } else if (closeTrigger) {
        e.preventDefault();
        closeSearch();
      }
    });

    if (psBackdrop) psBackdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && document.body.classList.contains('search-is-open')) {
        closeSearch();
      }
    });

    function psFormatPrice(val) {
      const n = parseFloat(val);
      if (isNaN(n)) return '';
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    }

    function psThumb(p) {
      const url = p.image || (p.featured_image && p.featured_image.url) || '';
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    }

    function renderResults(products, query) {
      psResults.innerHTML = '';
      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'ps-empty';
        empty.textContent = 'No matches for "' + query + '" yet. Try another artist, mood, or room.';
        psResults.appendChild(empty);
        return;
      }
      products.forEach(function(p) {
        const a = document.createElement('a');
        a.className = 'ps-result';
        a.href = p.url;

        const thumb = psThumb(p);
        if (thumb) {
          const img = document.createElement('img');
          img.className = 'ps-result-thumb';
          img.src = thumb;
          img.alt = '';
          img.loading = 'lazy';
          a.appendChild(img);
        }

        const text = document.createElement('div');
        text.className = 'ps-result-text';
        const parts = (p.title || '').split(' – ');
        const title = document.createElement('span');
        title.className = 'ps-result-title';
        title.textContent = parts[0] || p.title || '';
        text.appendChild(title);
        if (parts[1]) {
          const artist = document.createElement('span');
          artist.className = 'ps-result-artist';
          artist.textContent = (parts[1].split(', ')[0] || '').trim();
          text.appendChild(artist);
        }
        a.appendChild(text);

        const price = psFormatPrice(p.price_min || p.price);
        if (price) {
          const pr = document.createElement('span');
          pr.className = 'ps-result-price';
          pr.textContent = 'From ' + price;
          a.appendChild(pr);
        }
        psResults.appendChild(a);
      });

      const viewAll = document.createElement('a');
      viewAll.className = 'ps-viewall';
      viewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
      viewAll.textContent = 'View all results for "' + query + '"';
      psResults.appendChild(viewAll);
    }

    async function fetchSuggestions(query) {
      const reqId = ++psReqId;
      try {
        const resp = await fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6');
        if (!resp.ok) return;
        const data = await resp.json();
        if (reqId !== psReqId) return; // a newer keystroke superseded this one
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, query);
      } catch (err) { /* ignore network errors — form submit still works */ }
    }

    if (psInput) {
      psInput.addEventListener('input', function() {
        const q = psInput.value.trim();
        clearTimeout(psDebounce);
        if (q.length < 2) {
          psReqId++; // cancel any pending render
          psResults.innerHTML = '';
          return;
        }
        psDebounce = setTimeout(function() { fetchSuggestions(q); }, 200);
      });
    }
  }
})();

/* Announcement bar rotator — mobile only.
   Crossfades through the announce-item messages so all three show on small
   screens (where there's only room for one). Desktop keeps showing them all
   statically. Respects prefers-reduced-motion (static first message) and
   pauses advancing while the tab is hidden. */
(function () {
  var bar = document.querySelector('.announce');
  if (!bar) return;
  var items = bar.querySelectorAll('.announce-item');
  if (items.length < 2) return;

  var mqMobile = window.matchMedia('(max-width: 768px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var idx = 0, timer = null;

  function show(i) {
    for (var n = 0; n < items.length; n++) {
      items[n].classList.toggle('is-active', n === i);
    }
  }
  function start() {
    if (timer) return;
    bar.classList.add('is-rotating');
    idx = 0; show(0);
    timer = setInterval(function () {
      if (document.hidden) return;            // pause advancing while tab is hidden
      idx = (idx + 1) % items.length;
      show(idx);
    }, 4000);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    bar.classList.remove('is-rotating');
    for (var n = 0; n < items.length; n++) items[n].classList.remove('is-active');
  }
  function apply() {
    if (mqMobile.matches && !mqReduce.matches) start(); else stop();
  }

  apply();
  function on(mq, fn) { mq.addEventListener ? mq.addEventListener('change', fn) : mq.addListener(fn); }
  on(mqMobile, apply);
  on(mqReduce, apply);
})();

/* The Craft — mobile "tap for more" popup.
   On phones the grid is a compact 2x2 of number + title; tapping a card opens
   the popup with that step's full description. Desktop shows everything inline,
   so the popup stays dormant there. */
(function () {
  var grid = document.querySelector('.craft-grid');
  var popup = document.getElementById('craftPopup');
  if (!grid || !popup) return;

  var mq = window.matchMedia('(max-width:560px)');
  var numEl = popup.querySelector('.craft-popup-num');
  var titleEl = popup.querySelector('.craft-popup-title');
  var bodyEl = popup.querySelector('.craft-popup-body');
  var closeBtn = popup.querySelector('.craft-popup-close');
  var lastFocus = null;
  var hideTimer = null;

  function text(el, sel) { var n = el.querySelector(sel); return n ? n.textContent.trim() : ''; }

  function open(step) {
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    numEl.textContent = text(step, '.craft-num');
    titleEl.textContent = text(step, 'h3');
    bodyEl.textContent = text(step, 'p');
    popup.classList.toggle('is-signature', step.classList.contains('signature'));
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
    hideTimer = setTimeout(function () { popup.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  grid.addEventListener('click', function (e) {
    if (!mq.matches) return;                     // desktop shows full text inline
    var step = e.target.closest('.craft-step');
    if (step) open(step);
  });
  popup.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-craft-close')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) close();
  });
})();

/* Collection intro: hide the Read more / fade when the bio fits inside the clamp.
   Measures the clamped description; if it doesn't overflow, mark it .intro-fits
   (CSS then drops the clamp, fade, and toggle). Re-checks on resize. */
(function () {
  var intros = document.querySelectorAll('[data-collection-intro]');
  if (!intros.length) return;

  function check(intro) {
    var desc = intro.querySelector('.collection-description');
    var cb = intro.querySelector('.collection-desc-cb');
    if (!desc) return;
    // Only meaningful while collapsed — skip if the user has expanded it.
    if (cb && cb.checked) return;
    intro.classList.remove('intro-fits');
    var overflows = desc.scrollHeight - desc.clientHeight > 4;
    if (!overflows) intro.classList.add('intro-fits');
  }

  function checkAll() {
    intros.forEach(check);
  }

  checkAll();
  // Recompute after web fonts settle (line height can shift) and on resize.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkAll);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(checkAll, 150);
  });
})();

/* PDP description: drop the clamp/fade/toggle when the copy already fits inside the clamp.
   Same approach as the collection intro, keyed to a separate selector so the two never
   collide. Bails immediately on pages with no PDP description block. */
(function () {
  var blocks = document.querySelectorAll('[data-pdp-desc]');
  if (!blocks.length) return;

  function check(b) {
    var body = b.querySelector('.pdp-desc-body');
    var cb = b.querySelector('.pdp-desc-cb');
    if (!body) return;
    // Only meaningful while collapsed; skip if the user has expanded it.
    if (cb && cb.checked) return;
    b.classList.remove('desc-fits');
    if (body.scrollHeight - body.clientHeight <= 4) b.classList.add('desc-fits');
  }

  function checkAll() {
    blocks.forEach(check);
  }

  checkAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkAll);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(checkAll, 150);
  });
})();

/* Storewide reviews blocks (PDP pooled block + homepage carousel): reveal only once Junip
   actually fills the carousel, otherwise keep it hidden so an empty widget never leaves a
   blank gap. Covers .pdp-reviews-shop and any [data-junip-reveal] container. */
(function () {
  var blocks = document.querySelectorAll('.pdp-reviews-shop, [data-junip-reveal]');
  if (!blocks.length) return;
  blocks.forEach(function (block) {
    function hasContent(sel) {
      var el = block.querySelector(sel);
      return el && el.querySelector('*') && el.textContent.trim().length > 0;
    }
    function check() {
      if (hasContent('.junip-review-carousel')) {
        block.classList.add('is-populated');
        return true;
      }
      return false;
    }
    if (check()) return;
    var obs = new MutationObserver(function () { if (check()) obs.disconnect(); });
    obs.observe(block, { childList: true, subtree: true });
    // Give Junip time to load; if it never fills, the block stays hidden.
    setTimeout(function () { obs.disconnect(); }, 10000);
  });
})();

/* Search query normalization: Shopify's semantic search typo-correction only works on
   lowercase input (uppercase typos return unrelated padding), so lowercase q on every
   search form submit. Direct URL arrivals are intentionally left untouched. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    var path;
    try { path = new URL(form.action, location.origin).pathname; } catch (err) { return; }
    if (path !== '/search') return;
    var q = form.querySelector('input[name="q"]');
    if (q && q.value) q.value = q.value.toLowerCase();
  }, true);
})();
